import { ShieldCheck } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconShieldCheck12Line = createIcon(ShieldCheck, 12, "Line");
export const IconShieldCheck16Line = createIcon(ShieldCheck, 16, "Line");
export const IconShieldCheck20Line = createIcon(ShieldCheck, 20, "Line");
export const IconShieldCheck24Line = createIcon(ShieldCheck, 24, "Line");
export const IconShieldCheck32Line = createIcon(ShieldCheck, 32, "Line");
export const IconShieldCheck48Line = createIcon(ShieldCheck, 48, "Line");
export const IconShieldCheck64Line = createIcon(ShieldCheck, 64, "Line");
